<template>
  <a-modal
    width="702px"
    title="分配客户"
    :mask-closable="false"
    :visible="allotBusinessVisible"
    :allotUserId="allotUserId"
    @cancel="onCancelAllot"
    @ok="onSubmit"
  >
    <basic-form ref="allotBusinessRef" :form-data="allotBusinessColumns">
      <template #user_realname>
        <span>{{ allotUserName }}</span>
      </template>

      <template #allot_buesness>
        <a-select
          mode="multiple"
          placeholder="请为推广人分配客户"
          :showArrow="true"
          :allowClear="true"
          :value="businessListSelect"
          @change="onChange"
          :confirmLoading="true"
        >
          <a-select-option
            v-for="(item, index) in businessList"
            :key="index"
            :value="item.id + '_+_' + item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
    </basic-form>
  </a-modal>
</template>

<script>
import { allotBusinessColumns } from "../data/index";
export default {
  props: [
    "allotUserId",
    "allotBusinessVisible",
    "allotUserName",
    "currCompanyId",
  ],
  data() {
    return {
      allotBusinessColumns,
      businessList: [],
      businessListSelect: [],
    };
  },
  watch: {
    allotUserId(val) {
      this.getCustomerList();
    },
  },
  mounted() {},
  methods: {
    onChange(val, option) {
      this.businessListSelect = val;
    },
    onCancelAllot() {
      this.businessList = [];
      this.businessListSelect = [];
      this.$parent.allotBuesnessCancel();
    },
    // 保存分配
    async onSubmit() {
      let businessIds = this.businessListSelect.map((item) => {
        return item.substr(0, item.indexOf("_+_"));
      });

      let result = await this.$http.post("/promoter/saveAllotBusiness", {
        business_ids: businessIds,
        promoter_id: this.allotUserId,
        cooperation_company_id: this.currCompanyId,
      });

      if (result.data.status === 1) {
        this.businessList = [];
        this.businessListSelect = [];
        this.onCancelAllot();
      }
    },
    // 获取商业公司列表
    async getCustomerList() {
      if (!this.allotUserId) {
        return;
      }
      let result = await this.$http.post("/Customer/getList", {
        cooperation_company_id: this.currCompanyId,
        filter: 'allotBusiness',
        promoter_id: this.allotUserId,
        type: 3,
        no_diff: 1
      });

      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return {
            id: item.id,
            name: item.name,
          };
        });

        this.businessList = data;

        this.getCustomerSelectList();
      }
    },
    // 获取已分配的商业公司列表
    async getCustomerSelectList() {
      if (!this.allotUserId) {
        return;
      }

      let result = await this.$http.post("/promoter/getAllotBusiness", {
        promoter_id: this.allotUserId,
        cooperation_company_id: this.currCompanyId,
      });
      if (result.data.status === 1) {
        let selectList = result.data.data.map((item) => {
          return item.id + "_+_" + item.name;
        });

        this.businessListSelect = selectList;
      }
    },
  },
};
</script>

<style scoped>
/deep/.allot_buesness .ant-form-item-label label::after {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}
</style>